import { Client } from "@microsoft/microsoft-graph-client";
import { Buffer } from "buffer";
import { DriveItem, WorkbookWorksheet } from "microsoft-graph";
import { ClinicsEnum } from "../enums";
import { sanatizeDirtyClinicStringToEnum } from "../utils";

export interface SpecialtyClinicWorksheet extends WorkbookWorksheet {
  URI: string;
  clinicEnum: ClinicsEnum
}

export async function fetchRelevantWorksheets(
  graphClient: Client
): Promise<SpecialtyClinicWorksheet[]> {
  const CLINIC_AVAILABILITY_URL =
    "https://adminliveunc.sharepoint.com/:x:/s/ClinicAdministration/EXiIPdtOXGhNqeSbNwaQZ6sBmLe4dGK4cEndxfpCQGTvXg?email=hudson15%40live.unc.edu&e=4%3AP3po3H&at=9&CID=f29c3ccb-0c4d-34b2-5ad2-0419894b4e0b";
  const CLINIC_UN_AVAILABILITY_URL =
    "https://adminliveunc.sharepoint.com/:x:/s/ClinicAdministration/Ee9DoUkZwX9JvX68m_V__MgBV_QuxdetIAWllyenvs41hA";

  const isVisable = (ws: WorkbookWorksheet) => ws.visibility !== "Hidden";
  const isMatchingToKnownClinic = (ws: WorkbookWorksheet) =>
    sanatizeDirtyClinicStringToEnum(ws.name) !== undefined;

  const availability_worksheets =
    await fetchWorksheetsFromURLTrueToTheFollowing(
      CLINIC_AVAILABILITY_URL,
      [isVisable, isMatchingToKnownClinic],
      graphClient
    );
  const un_availability_worksheets =
    await fetchWorksheetsFromURLTrueToTheFollowing(
      CLINIC_UN_AVAILABILITY_URL,
      [isVisable, isMatchingToKnownClinic],
      graphClient
    );
    
    return [...availability_worksheets,...un_availability_worksheets]
}

async function fetchWorksheetsFromURLTrueToTheFollowing(
  sharingURL: string,
  predicates: Function[],
  graphClient: Client
) {
  const encodeSharepointUrl = (url: string) => {
    let sharingUrl = url;
    let base64Value = Buffer.from(sharingUrl).toString("base64");
    let encodedUrl =
      "u!" +
      base64Value.replace(/=$/, "").replace("///g", "_").replace("/+/g", "-");
    return encodedUrl;
  };
  let endocedUrl = encodeSharepointUrl(sharingURL);
  let driveItem: DriveItem = await graphClient
    .api(`/shares/${endocedUrl}/driveItem`)
    .get();
  const driveId = driveItem.parentReference?.driveId; //b!sl86wKv1zUyqDqRFsPmZ-5UBv8-0fLNDhD8OmoKlR5aw8H2kTcgFRZlMwkq4-9kf
  const itemId = driveItem.id; //01HWQ5X7L6NIHMXBYSQNGJCNKDACNIDVSN
  let workbook = await graphClient
    .api(
      `https://graph.microsoft.com/v1.0/drives/${driveId}/items/${itemId}/workbook/worksheets`
    )
    .get();
  let worksheets: WorkbookWorksheet[] = workbook.value;
  return worksheets.reduce(function (filtered: SpecialtyClinicWorksheet[], ws) {
    if (
      predicates.every((predicateFunction) => predicateFunction(ws) === true)
    ) {
      var someNewValue = {
        ...ws,
        clinicEnum: sanatizeDirtyClinicStringToEnum(ws.name)!,
        URI: `https://graph.microsoft.com/v1.0/drives/${driveId}/items/${itemId}/workbook/worksheets('${ws.id}')/`,
      };
      filtered.push(someNewValue);
    }
    return filtered;
  }, []);
}
